import { get as lodashGet, set as lodashSet } from 'lodash';

export function prepareModel(originalItems, modelDestination) {
  const items = originalItems.slice();
  const addModelToItem = item => {
    if (item && !item.hasOwnProperty('model')) {
      Object.defineProperty(item, 'model', {
        get: () => {
          return lodashGet(modelDestination.ad.building.infrastructure, item.modelName);
        },
        set: value => {
          if (!modelDestination.ad.building.infrastructure) {
            modelDestination.ad.building.infrastructure = {};
          }

          lodashSet(modelDestination.ad.building.infrastructure, item.modelName, value);
        },
      });
    }

    return item;
  };

  return items.map(addModelToItem);
}

export function extractItems(objectType, items, context) {
  try {
    const needModels = context(`./${objectType}.js`).default;

    return items.filter(item => needModels.includes(item.modelName));
  } catch (e) {
    return [];
  }
}
